export default __webpack_public_path__ + "static/media/photographyColor.2f1a4e03.png";